import * as graphql from '@treams/treams-network';

import { useWorkspace } from './useWorkspace';

export function useFeatureNeedsViewerApproval(id: graphql.FeatureName): {
	needsViewerApproval: boolean;
	refetch: () => void;
} {
	const { data, refetch } = graphql.useFeaturesQuery({
		variables: {
			id: useWorkspace().id,
		},
	});

	const feature = data?.workspace.features.find((feature) => feature.feature.id === id);

	return {
		needsViewerApproval: feature?.needsViewerApproval ?? false,
		refetch,
	};
}
